/* eslint-disable spaced-comment */
import { Message } from 'element-ui'
import contractApi from '@/xhr/services/contract'

export function underDevelopment() {
  Message.warning('点我无效，此功能已被封禁，且尚在评审中。')
}

export function messageCancel(action) {
  const dict = {
    delete: '删除',
  }
  Message.info(`已取消${dict[action] || action || '操作'}。`)
}

export function report(data, type = '', success, error) {
  let map = {
    create: '新增',
    update: '修改',
    destroy: '删除',
  }
  let msg = map[type] || type || '操作'

  if (data.code === 200) {
    Message.success(msg + '成功。')
    success && typeof success === 'function' && success(data)
  } else if (data.code !== 403) {
    Message.error(msg + '失败。' + data.msg)
    error && typeof error === 'function' && error(data)
  }
}

export function enum2options(ennum) {
  let arr = []
  for (let p in ennum) {
    let option = {
      label: p,
      value: ennum[p],
    }
    arr.push(option)
  }
  return arr
}

// 下载函数
export function download(src) {
  var download_file = {}
  if (typeof download_file.iframe === 'undefined') {
    var iframe = document.createElement('iframe')
    download_file.iframe = iframe
    document.body.appendChild(download_file.iframe)
  }
  download_file.iframe.src = src
  download_file.iframe.style.display = 'none'
}
// 去除 字符串两端空格
export const dealWithBlank = obj => {
  for (var i in obj) {
    if (obj[i] && isString(obj[i])) {
      obj[i] = obj[i].replace(/^\s*|\s*$/g, '')
    }
  }
  return obj
}
export const isString = str => {
  return typeof str === 'string' && str.constructor === String
}

// 根据给定日期和时间跨度获取 结果日期
export const getExpectDate = data => {
  //  期望日期跨度单位 起始日期 期望日期数字 登录人id
  let { contractEndTimeType, nowTime, value, loginId } = data
  let params = {
    contractEndTimeType,
    nowTime,
    value,
    loginId,
  }
  return new Promise((resolve, reject) => {
    contractApi.contract.getContractEndTime(params).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        this.$message.error('获取日期失败')
        reject()
      }
    })
  })
}

export const exportUtilWithBase64 = {
  /** 通过base64字符串生成文件 */
  downloadFileByBase64: function(base64Str, fileName) {
    var myBlob = this.dataURLtoBlob(base64Str)
    var myUrl = URL.createObjectURL(myBlob)
    this.downloadFile(myUrl, fileName)
  },
  /**封装base64Str blob对象*/
  dataURLtoBlob: function(base64Str) {
    // eslint-disable-next-line one-var
    var bstr = window.atob(base64Str),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    // alert(JSON.stringify(bstr));
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr])
  },
  /**创建一个a标签，并做下载点击事件*/
  downloadFile: function(hrefUrl, fileName) {
    var a = document.createElement('a')
    a.setAttribute('href', hrefUrl)
    a.setAttribute('download', fileName)
    a.setAttribute('target', '_blank')
    a.style.display = 'none'
    let clickEvent = document.createEvent('MouseEvents')
    clickEvent.initEvent('click', true, true)
    a.dispatchEvent(clickEvent)
  },
}



// WEBPACK FOOTER //
// ./src/lib/utils.js